/* eslint-disable jsx-a11y/no-autofocus */
import { SubmitButton } from "@design-system/components/Button";
import { TextInput } from "@design-system/components/Form";
import { trans, plainTrans } from "@mongez/localization";
import { Form } from "@mongez/react-form";
import { useUnlockCode } from "../../hooks/useUnlockCode";

export function UnlockCodeForm() {
  const { handleSubmit } = useUnlockCode();

  return (
    <Form onSubmit={handleSubmit}>
      <div className="space-y-4">
        <TextInput
          name="code"
          label={trans("unlockCode.activationCode")}
          placeholder={plainTrans("unlockCode.enterCodePlaceholder")}
          required
          autoFocus
          className="w-full"
        />

        <SubmitButton className="w-full">
          {trans("unlockCode.submit")}
        </SubmitButton>
      </div>
    </Form>
  );
}
